import React from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { t } from 'Src/i18n';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
import { FacilityHours } from 'Components/widgets/facility-hours/FacilityHours';
type Props = {
  bookATable: string;
  facilities: Array<ProductFacility>;
  onFacilityClick?: () => void;
  onTabClick?: (headerId: string, index: number) => void;
  openingHours: string;
};
export const FacilitiesHours = ({
  bookATable,
  facilities,
  onFacilityClick,
  onTabClick,
  openingHours,
}: Props) => {
  const items = facilities.map((item) => ({
    header: {
      color: COLORS.BLACK,
      title: item.label,
    },
    content: (
      <FacilityHours
        buttonLabel={bookATable}
        facility={item}
        key={item.id}
        onClick={onFacilityClick}
        openingHoursLabel={openingHours}
      />
    ),
  }));
  return (
    <Tabs
      id="product-facilities-line-tabs"
      isContentUnmountedOnCollapse
      isScrollable
      items={items}
      onTabClick={onTabClick}
      scrollBackwardLabel={t('common.scrollBackward')}
      scrollForwardLabel={t('common.scrollForward')}
    />
  );
};
